import * as React from "react";
import "./filters.scss";
import ButtonTertiary from "../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import ButtonSecondary from "../../../hiberUiKit/src/atoms/Buttons/ButtonSecondary";

interface IProps {
	/**
	 * On cancel
	 */
	onCancel: () => any
	/**
	 * On done click
	 */
	onDone: () => any
	/**
	 * Done text
	 */
	doneText? : string;
	/**
	 * Button done disability indicator
	 */
	disabled?: boolean
}

export default class FilterButtons extends React.Component<IProps, {}> {
	render() {
		return (
			<div className={"c-filter_buttons"}>
				<ButtonTertiary label={"Cancel"}
								onClick={this.props.onCancel}/>
				<ButtonSecondary disabled={this.props.disabled}
								 label={this.props.doneText? this.props.doneText : "Done"}
								 onClick={this.props.onDone}/>
			</div>
		);
	}

}
